import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAYMENTS_UNDERWRITING_SUPPORT_SLACK = 'https://hubspot.slack.com/archives/C02N4A8930V';
function PaymentEscalation() {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "1000",
    as: "div",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      style: {
        textAlign: 'center'
      },
      align: "start",
      direction: "row",
      justify: "center",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        "data-test-id": "payment-illustration",
        name: "payments-button",
        width: "33%"
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        "data-test-id": "payment-escalation-body",
        message: "app.escalations.payment.description_jsx",
        elements: {
          UILink
        },
        options: {
          href: PAYMENTS_UNDERWRITING_SUPPORT_SLACK,
          external: true
        }
      })]
    })
  });
}
export default PaymentEscalation;